
<template>
  <div class="public-layout">

    <!-- Navbar -->
    <Navbar />

    <!-- Main page -->
    <main id="main-content" class="public-content">
      <slot />
    </main>

    <!-- Footer -->
    <Footer />

  </div>
</template>

<script>
import Navbar from "../components/common/Navbar.vue";
import Footer from "../components/common/Footer.vue";

export default {
  name: "PublicLayout",

  components: {
    Navbar,
    Footer,
  },
};
</script>

<style scoped>
.public-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.public-content {
  flex: 1;
  width: 100%;
  min-width: 0;
}
</style>
